export default __webpack_public_path__ + "static/media/ZBTC.85fd3ba6.svg";